// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__Z5zgY","cardHeader":"styles_cardHeader__hUcnw","buttons":"styles_buttons__3ZeQP"};